import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faBars as fasBars,
    faHome as fasHome,
    faCalendarTimes as fasCalendarTimes,
    faDumbbell as fasDumbbell,
    faImages as fasImages,
    faEnvelope as fasEnvelope,
    faSpinner as fasSpinner,
} from '@fortawesome/free-solid-svg-icons'

import {
    faFacebook as fabFacebook,
    faInstagram as fabInstagram
} from '@fortawesome/free-brands-svg-icons'

library.add(
    // Solid
    fasBars,
    fasHome,
    fasCalendarTimes,
    fasDumbbell,
    fasImages,
    fasEnvelope,
    fasSpinner,
    // Brands
    fabFacebook,
    fabInstagram
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
